<template>
	<div class="navbar-default sidebar" role="navigation">
		<div class="sidebar-nav">
			<div id="sidebar-nav-inner">
				<ul class="nav" id="side-menu">
					<li>
						<router-link tags="a" to="/namespaces" class="tests_menu_namespaces_action">
							<i class="fa fa-coins fa-fw"></i> <span class="narrow-hide">Namespaces</span></router-link>
					</li>
					<li>
						<router-link tags="a" to="/tokens" class="tests_menu_tokens_action">
							<i class="fa fa-key fa-fw"></i> <span class="narrow-hide">Tokens</span></router-link>
					</li>
					<li>
						<router-link tags="a" to="/quotas" class="tests_menu_quotas_action">
							<i class="fa fa-tachometer-alt fa-fw"></i> <span class="narrow-hide">Quotas</span></router-link>
					</li>
					<li v-if="superadmin">
						<router-link tags="a" to="/users" class="tests_menu_tokens_action">
							<i class="fa fa-user fa-fw"></i> <span class="narrow-hide">Users</span></router-link>
					</li>
					<li v-if="superadmin">
						<router-link tags="a" to="/health" class="tests_menu_tokens_action">
							<i class="fa fa-heartbeat fa-fw"></i> <span class="narrow-hide">Health</span></router-link>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
const auth = require("@/utils/auth");
import router from "@/router";

export default {
  name: "app-menu",
  data: function() {
    return {
      superadmin: auth.isSuperAdmin()
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
li {
  text-align: left;
  word-break: break-all;
}
.sidebar ul li {
  border: 0;
}
.navbar-top-links li a {
  padding: 15px 0 15px 15px;
}
.sidebar ul li a.active {
  background: transparent;
}
.sidebar ul li a.router-link-active {
  border-top-width: 1px;
  border-bottom-width: 1px;
  border-left-width: 1px;
  border-right-width: 0;
  border-style: dashed;
  border-color: #a4abbd;
  background-color: #f8f8f8;
  margin-right: -1px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/Menu.vue